/**
 * Typed reads for a credential's probe (file-tree) state: `state.probe[credentialId]`.
 */

/** A node in the normalized probe tree (`state.probe[credId].tree`, flat map keyed by path). */
export interface ProbeTreeNode {
  id: string;
  path: string;
  fullPath?: string;
  name: string;
  displayName?: string;
  parent: string | null;
  type?: string; // 'file' | 'folder' (often omitted on folders)
  children?: string[];
  size?: number;
  updatedAt?: string;
  mimeType?: string;
  scanned?: boolean;
}

export interface ProbeCredentialState {
  tree?: Record<string, ProbeTreeNode>;
  treeLastUpdatedAt?: number;
  error?: string | null;
  /** File contents fetched by probeGetFile, keyed by path. */
  files?: Record<string, { response?: string } | undefined>;
  [key: string]: unknown;
}

export interface ProbeRootState {
  probe?: Record<string | number, ProbeCredentialState | undefined>;
}

export function selectProbeByCredentialId(
  state: ProbeRootState,
  credentialId: number | string | null | undefined,
): ProbeCredentialState | undefined {
  return credentialId != null ? state?.probe?.[credentialId] : undefined;
}
